<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">BU Page</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>BU Page List</h2>
      <v-spacer></v-spacer>
      <!-- <button class="btn btn-primary" @click="toBUPageCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增BU Page</span>
      </button> -->
    </div>
    <!-- block -->
    <div class="block mb-10">
      <BUPageTable></BUPageTable>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BUPageTable from '@/views/B-3__BUPage/c/BUPageTable.vue';

export default {
  components: {
    BUPageTable,
  },
  async created() {
    this.clear();
    await this.getBus();
  },
  methods: {
    ...mapActions('bupage', {
      getBus: 'find',
      clear: 'clear',
    }),
    toBUPageCreate() {
      this.$router.push({ name: 'BUPageCreate' });
    },
  },
};
</script>

<style></style>
